import styled from "styled-components";

export const Title = styled.p`
  font-size: 3.2rem;
  font-weight: bold;
  padding-top: 1.6rem;
`;

export const Grid = styled.div`
  padding-top: 1.6rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.6rem;
`;
